import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleMessageFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.8087 2.51074C14.2042 2.51079 16.602 3.42823 18.4278 5.25977C22.0843 8.92995 22.0784 14.872 18.4278 18.5352C15.5718 21.4018 11.3419 22.0223 7.88189 20.4249C7.38637 20.2246 7.1393 20.1403 6.94146 20.1397C6.79154 20.1408 6.60013 20.1797 6.3477 20.2569C6.22409 20.2947 6.09711 20.3386 5.96001 20.3858L5.92876 20.3965C5.80429 20.4395 5.66966 20.4857 5.53715 20.5274C5.25927 20.6149 4.91784 20.707 4.57328 20.7071C4.20294 20.7071 3.79739 20.5993 3.46488 20.2657C3.13246 19.9321 3.02634 19.526 3.0264 19.1563C3.02651 18.812 3.11737 18.4703 3.20414 18.1915C3.24489 18.0605 3.29009 17.9272 3.33207 17.8038C3.3363 17.7913 3.34061 17.7789 3.34476 17.7666C3.39153 17.629 3.43438 17.5013 3.47172 17.377C3.54828 17.1221 3.58597 16.9281 3.58597 16.7754C3.58597 16.5729 3.50509 16.3312 3.30668 15.833C1.71481 12.3637 2.3346 8.12537 5.1895 5.25977C7.01542 3.42819 9.41307 2.51074 11.8087 2.51074Z",
		fill: "currentColor"
	})
});
export default SvgCircleMessageFill;
